import { Injectable } from '@angular/core';
import {GeneralResponse} from '../../parametre/parametre.model';
import {map} from 'rxjs/operators';
import {Structure} from '../../structure/models/structure.model';
import {AuthService} from '../../securite/service/auth.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import {ToasterService} from '../../../globalServices/toaster.service';
import {Observable, Subject} from 'rxjs';
import {Candidat} from '../models/candidat.model';
import {Fichier} from '../../securite/auth.model';
import {MatDialog} from '@angular/material/dialog';
import {ParametreService} from '../../parametre/parametre.service';
import {Information} from '../../admin/admin.model';
import {ModalContentComponent} from '../../admin/gestion-information/modal-content/modal-content.component';
import {ModalService} from '../../../services/modal.service';

@Injectable({
  providedIn: 'root'
})
export class CandidatService {

    public candidat= new Candidat();
    public candidat_is_lorading=true;
    candidatSubject = new Subject<Candidat>();
    urlFile: string;
    constructor(
      private authservice: AuthService,
      private http: HttpClient,
      private router: Router,
      private toastr: ToasterService,
      private dialog: MatDialog,
      private parametreService: ParametreService,
      private modalService: ModalService


    ) { }

  getCandidatDataByUser(user_id: number,is_dashboard:boolean) {
      this.candidat_is_lorading=true;
    this.http.post<GeneralResponse>(this.authservice.urlApi + '/candidat/by/user', {
      'user_id': `${user_id}`
    }, {headers:this.authservice.getHeaders()}).pipe(
        map((response: GeneralResponse) => {
          const data = response.data as Candidat; // Type assertion for clarity
          console.log('response candidat', response);
          return data;
        })
    ).subscribe(
        {
          next: (response: Candidat) => {
            this.candidat = response;
            console.log('this.candidat response', response);
            if(Object.keys(this.candidat).length === 0 ||this.candidat ==null || (this.candidat!=null && this.candidat.id ==0)) {
                if(!is_dashboard) {
                    if(this.authservice.loggedUser.telephone==undefined){
                        this.modalService.openPhoneModal();

                    }else{
                        this.router.navigate(['/candidat','new']);

                    }

                }

                // if(!this.candidat.profil_is_valide){
                //     this.router.navigate(['/candidat','edit']);
                //
                // }
            }else {

                if(!is_dashboard) {
                    if(this.authservice.loggedUser.telephone==undefined){
                        this.modalService.openPhoneModal();

                    }else{
                        if(!this.candidat.profil_is_valide){

                            this.router.navigate(['/candidat','edit']);

                        }
                    }

                }

              //console.log('candidat exist', this.candidat);
                this.candidat.url_cv =this.candidat.id_cv_file==undefined?undefined: this.getFileData(this.authservice.loggedUser.fichiers, this.candidat.id_cv_file).url;
                this.candidat.url_piece_id = this.candidat.id_piece_id_file==undefined?undefined: this.getFileData(this.authservice.loggedUser.fichiers, this.candidat.id_piece_id_file).url;

              this.emitCandidat();
                this.candidat_is_lorading=false;

            }
          },
          error(err: any) {
            let erreurGeneral = new GeneralResponse();
            erreurGeneral = err;
            //console.log('oops', erreurGeneral);
              this.candidat_is_lorading=false;

          }

        }
    );

  }

    getCandidatForInfoByUser(user_id: number,role_id: number,type:string) {
        // this.candidat_is_lorading=true;
        this.http.post<GeneralResponse>(this.authservice.urlApi + '/candidat/by/user', {
            'user_id': `${user_id}`
        }, {headers:this.authservice.getHeaders()}).pipe(
            map((response: GeneralResponse) => {
                const data = response.data as Candidat; // Type assertion for clarity
                //console.log('response candidat', response);
                return data;
            })
        ).subscribe(
            {
                next: (response: Candidat) => {
                    this.candidat = response;
                    //console.log('response', response);
                    if(Object.keys(this.candidat).length === 0 ||this.candidat ==null || (this.candidat!=null && this.candidat.id ==0)) {
                        //console.log('candidat exist pas', this.candidat);
                        this.parametreService.getInfos(this.parametreService.getHeaders(),role_id,type)
                            .subscribe(
                                {
                                    next: (responses: Information[]) => {

                                        if (responses != undefined && responses.length > 0) {
                                            const infos :Information[] = responses.filter(item => item.isDefault === true);
                                            //console.log("Information a afficher",infos);

                                            var htmlString = infos.map(info => `${info.titre} ${info.contenu}`).join('<br>');


                                            //console.log("Information htmlString",htmlString);

                                            this.dialog.open(ModalContentComponent, {
                                                data: htmlString,
                                                width: '900px',
                                                // height: '600px',
                                            });
                                        }else {
                                            //console.log("Information a afficher vide",responses);

                                        }
                                    },
                                }
                            );


                    }else {

                    }
                },
                error(err: any) {
                    let erreurGeneral = new GeneralResponse();
                    erreurGeneral = err;
                    //console.log('oops', erreurGeneral);
                    // this.candidat_is_lorading=false;

                }

            }
        );

    }

    emitCandidat() {
        this.candidatSubject.next(this.candidat);
    }

    createCandidat(candidatData: any): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.authservice.getToken()}`
            })
        };

        return this.http.post<any>(this.authservice.urlApi + '/candidat/add', candidatData, {headers:this.authservice.getHeaders()});
    }

    updateCandidat(candidatData: any): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.authservice.getToken()}`
            })
        };

        return this.http.put<any>(this.authservice.urlApi + '/candidat/update', candidatData, {headers:this.authservice.getHeaders()});
    }
    validerCandidat(candidatData: any): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.authservice.getToken()}`
            })
        };

        return this.http.put<any>(this.authservice.urlApi + '/candidat/valider', candidatData, {headers:this.authservice.getHeaders()});
    }
    getFileData(list: Fichier[], item_id: number):Fichier{
        //console.log("listfile",list,"item",item_id);
        let file:Fichier= list.find(value => value.id==item_id);
        //console.log("file",file);

        return file;
    }


}
